export default __webpack_public_path__ + "static/media/github-gold.5f214586.png";